app.controller('HybridCtrl', [
    '$scope',
    '$http',
    '$translate',
    'toaster',
    '$ngConfirm',
    '$timeout',
    function($scope, $http, $translate, toaster, $ngConfirm, $timeout) {
        $scope.SWITCHER_TAB = 1;
        $scope.ANALYZER_TAB = 2;

        $scope.form = {
            hybrid: {
                id: null,
                exists: false,
                searched: false,
                json: {},
                isMssql: true,
                isPsql: false,
            },
            analyze: {
                id: null,
                loading: false,
                json: {},
                searched: false,
            },
        };

        $scope.init = function() {
            $scope.tab = $scope.ANALYZER_TAB;
        };

        $scope.changeTab = function(v) {
            $scope.tab = v;
        };

        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };

        console.log('hello !');

        $scope.searchHybridId = function(id) {
            $http.get(`/rest-api/debugging/hybrid/switcher/${id}`).then(
                function(response) {
                    if (response.data) {
                        $scope.form.hybrid.exists = true;
                        $scope.form.hybrid.json = response.data;

                        $scope.form.hybrid.isMssql = response.data.isMssql;
                        $scope.form.hybrid.isPsql = response.data.isPsql;
                    } else {
                        $scope.form.hybrid.exists = false;
                        $scope.form.hybrid.json = {};

                        $scope.form.hybrid.isMssql = true;
                        $scope.form.hybrid.isPsql = false;
                    }

                    $scope.form.hybrid.searched = true;
                },
                function() {
                    toaster.error(
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('hybrid.toastr.error.search')
                    );
                }
            );
        };

        $scope.closeHybrid = function() {
            $scope.form.hybrid = {
                id: null,
                exists: false,
                searched: false,
                json: {},
                isMssql: true,
                isPsql: false,
            };
        };

        $scope.changeHybridId = function(form) {
            $http
                .put(`/rest-api/debugging/hybrid/switcher/${form.id}`, {
                    isPsql: form.isPsql,
                    isMssql: form.isMssql,
                })
                .then(
                    function() {
                        var id = form.id;

                        $timeout(function() {
                            $scope.form.hybrid.id = id;

                            $scope.searchHybridId(id);
                        }, 500);

                        $scope.closeHybrid();

                        toaster.success(
                            $translate.instant('general.toastr.error.header'),
                            $translate.instant('hybrid.toastr.success.save')
                        );
                    },
                    function() {
                        toaster.error(
                            $translate.instant('general.toastr.error.header'),
                            $translate.instant('hybrid.toastr.error.save')
                        );
                    }
                );
        };

        function analyzeRequestPromiseSuccess(response) {
            $scope.form.analyze.loading = false;
            $scope.form.analyze.searched = true;
            $scope.form.analyze.json = response.data;
        }

        function analyzeRequestPromiseError() {
            $scope.form.analyze.loading = false;
            $scope.form.analyze.searched = false;
            $scope.form.analyze.json = {};

            toaster.error(
                $translate.instant('general.toastr.error.header'),
                $translate.instant('hybrid.toastr.error.analyze')
            );
        }

        $scope.searchAnalyzeId = function(id) {
            $scope.form.analyze.loading = true;

            $http
                .get(`/rest-api/debugging/hybrid/analyzer/${id}`)
                .then(analyzeRequestPromiseSuccess, analyzeRequestPromiseError);
        };

        $scope.searchAnalyzeAll = function() {
            $scope.form.analyze.loading = true;

            $http
                .get(`/rest-api/debugging/hybrid/analyzer`)
                .then(analyzeRequestPromiseSuccess, analyzeRequestPromiseError);
        };

        $scope.closeAnalyze = function() {
            $scope.form.analyze = {
                id: null,
                loading: false,
                json: {},
                searched: false,
            };
        };

        $scope.init();
    },
]);
